module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/MagicAdTileDesktop-48acbcab2a624b9d0e816d6ec20f0917.png";